import { useDataSubmit, useDataValue, useDataChange } from 'Simple/Data.js'

export function isTagSelected(tag_id, tags) {
  return tags?.some(tag => tag.id === tag_id)
}

export function useOnClick(props) {
  let change = useDataChange({
    context: 'event_action',
    path: 'data.tags',
    viewPath: props.viewPath,
  })

  let tag = useDataValue({
    context: 'tag',
    viewPath: props.viewPath,
  })

  let tags = useDataValue({
    context: 'event_action',
    path: 'data.tags',
    viewPath: props.viewPath,
  })

  let changeSearchTerm = useDataChange({
    context: 'tags_picker',
    path: 'search_term',
    viewPath: props.viewPath,
  })

  return function onClick() {
    let should_remove = isTagSelected(tag.id, tags)

    change(
      should_remove ? tags.filter(({ id }) => id !== tag.id) : [...tags, tag]
    )

    changeSearchTerm('')
  }
}

export function useOnClickEdit(props) {
  let submit = useDataSubmit({
    context: 'tags_picker',
    viewPath: props.viewPath,
  })

  let value = useDataValue({
    context: 'tag',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'open_edit_tag',
      value,
    })
  }
}
